import { C, fonts } from "../theme.js";
import { LOGO_CLIENTS } from "../content.js";

export const LogoStrip = () => (
  <section style={{ background: C.bg, padding: "60px 40px 100px" }}>
    <div style={{ maxWidth: 1280, margin: "0 auto" }}>
      <div
        style={{
          textAlign: "center",
          fontFamily: fonts.mono,
          fontSize: 11,
          color: C.faint,
          letterSpacing: "0.24em",
          marginBottom: 32,
        }}
      >
        TRUSTED BY TEAMS AT
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
          gap: 0,
          borderTop: `1px solid ${C.border}`,
          borderBottom: `1px solid ${C.border}`,
        }}
      >
        {LOGO_CLIENTS.map((c, i) => (
          <div
            key={i}
            style={{
              padding: "26px 12px",
              textAlign: "center",
              fontFamily: fonts.serif,
              fontStyle: "italic",
              fontSize: 22,
              fontWeight: 500,
              color: "#888",
              letterSpacing: "0.04em",
              borderRight: i < LOGO_CLIENTS.length - 1 ? `1px solid ${C.border}` : "none",
            }}
          >
            {c}
          </div>
        ))}
      </div>
    </div>
  </section>
);
